<template>
  <div id="contact-form-success-modal">
    <div class="modal-container">
      <div class="close-btn-photo">
        <span @click="$emit('close')"><i class="fa-solid fa-xmark fa-lg"></i></span>
      </div>
      <div class="top-banner">
        <div class="w-100 d-flex flex-column justify-content-center align-items-center" style="gap: 10px;">
          <i class="fa-regular fa-circle-check"></i>
          <p class="text-green text-center raleway-semi-p24">NOUS AVONS BIEN REÇU VOTRE DEMANDE</p>
          <p class="text-center raleway-reg-p15">Notre équipe vous recontactera dans les plus brefs délais afin de répondre à votre demande.</p>
          <div class="d-flex w-100 justify-content-center align-items-center mt-4">
            <div class="hortense-btn-primary" @click="goToHomePage()">REVENIR À LA PAGE D’ACCUEIL</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-contact-form-success',
  methods: {
    goToHomePage() {
      window.location.href = '/';
    }
  }
}
</script>
<style scoped lang="scss">
#contact-form-success-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; // backdrop layer behind the modal

  .modal-container {
    position: relative;
    bottom: 12%;
    width: 878px;
    height: 458px;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    overflow-y: auto;
    z-index: 1000; // modal above backdrop
    padding: 45px;

    .close-btn-photo {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;

      span {
        width: 12px;
        height: 13px;
        color: #3B6152;
      }
    }

    .header {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .lodging-name {
        margin-left: 6rem;

        img {
          width: 45px;
          position: absolute;
        }
      }
    }
  }

  @media only screen and (max-device-width: 480px) {
    .modal-container {
      width: 100% !important;
      z-index: 1001;
      padding: 20px;
    }
  }

  .top-banner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    i {
      font-size: 69px;
      color: #3B6152;
      margin-bottom: 20px;
    }
  }

  .text-green {
    color: #3B6152;
  }
}

</style>